import { makeStyles } from '@material-ui/core/styles';
import { r2PaletteColors } from '../layout/themes'
import {
    ChipField,
    ChipFieldProps,
    useRecordContext,
    useTranslate,
} from 'react-admin';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';

const useChipClasses = makeStyles(theme => ({
    chip: (props: any) => {
        const { record, value, choices, variant } = props
        // console.log(props)
        const colors = Object.values(r2PaletteColors)
        const choicesPK = groupBy(choices, 'id')
        let bgColor, fgColor

        if (choices) {
            const c = choicesPK[value]
            bgColor = (c && c[0]?.color) || theme.palette.grey[600]
            fgColor = (c && c[0]?.textColor) ? c[0]?.textColor : theme.palette.secondary.contrastText
        }
        else {
            bgColor = record.data?.color ?
                record.data?.color : colors[(record.id - 1) % colors.length]
            fgColor = record.data?.textColor ? record.data?.textColor : theme.palette.secondary.contrastText
        }

        let outColors
        if (variant === 'outlined') {
            outColors = {
                borderColor: bgColor,
                color: bgColor,
                '& .MuiChip-icon': {
                    color: bgColor
                }
            }
        } else {
            outColors = {
                backgroundColor: bgColor,
                color: fgColor,
                '& .MuiChip-icon': {
                    color: theme.palette.secondary.contrastText
                }
            }
        }

        return outColors
    }
}))

const ColoredChipField = (props: JSX.IntrinsicAttributes & ChipFieldProps & { children?: React.ReactNode; choices?: any[] }) => {
    const { choices, source, variant } = props
    const record = useRecordContext(props);
    const value: string = get(record, source!);
    const translate = useTranslate()

    let IconLabel
    let newLabel = { name: value as string }
    const classes = useChipClasses({ record, value, choices, variant });

    if (choices) {
        const choicesPK: { [key: string]: any } = groupBy(choices, 'id')
        const c = (choicesPK[value] && choicesPK[value].length > 0) ? choicesPK[value][0] : null
        newLabel = c || { ...choicesPK['DEFAULT'], name: (value as string)?.toLowerCase() };
        IconLabel = newLabel && c?.icon
        // console.log(IconLabel)
    }
    // console.log(newLabel)
    // console.log(IconLabel)


    return (
        <ChipField
            {...props}
            icon={!!IconLabel ? <IconLabel /> : undefined}
            className={classes.chip}
            record={{ ...record, [source!]: translate(newLabel.name) }}
        />
    );
};

export default ColoredChipField